import { toast } from '@navi/web-ui/lib/primitives/Toast';
import axiosInstance, { ApiKeys, getApiUrl, logError } from '@cp/src/utils/ApiHelper';

export const sendCallRecordingAuditAndDownload = (
  interactionId: string,
  phoneNumber: string,
  loanAccountNumber: string,
  audioUrl: string,
  userReferenceId: string,
  filename: string
) => {
  const url = getApiUrl(ApiKeys.DOWNLOAD_CALL_RECORDING);
  const data = {
    entityId: loanAccountNumber,
    callRecordingUrl: audioUrl,
    phoneNumber: phoneNumber,
    userReferenceId: userReferenceId,
    interactionId: interactionId
  };
  axiosInstance
    .post(url, data, {
      headers: {
        donotHandleError: true
      }
    })
    .then(() => {
      downloadCallRecording(audioUrl, filename);
    })
    .catch(() => {
      toast.error('Error sending call recording audit');
    });
};

export const downloadCallRecording = async (url: string, fileName: string) => {
  const downloadLink = document.createElement('a');
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Network response was not ok`);
    }
    const blob = await response.blob();
    const objectURL = URL.createObjectURL(blob);
    downloadLink.href = objectURL;
    downloadLink.download = fileName;
    downloadLink.rel = 'noopener noreferrer';
    downloadLink.click();
    URL.revokeObjectURL(objectURL);
    toast.success('Audio file downloaded successfully');
  } catch (error) {
    logError('Error downloading the audio file');
  }
};
